import { combineReducers } from "redux";
// Public Pages Reducers
import MobileHomepage from "./homepage/reducer";
import AllProducts from "../layouts/innerComponent/AllProducts/reducer";
import BestSeller from "./bestSeller/reducer";
import FeaturedProducts from "./featuredProducts/reducer";
import TopFiveProducts from "./topFive/reducer";
import EntertainmentProducts from "./EntertainmentProducts/reducer";
import SlidersData from "./fetchSlider/reducer";
import SelectedCategory from "./categorySelect/reducer";
import Denominations from "./productDetails/reducer";
import ProductDetail from "./productInfo/reducer";
import productByCategories from "./productsByCategory/reducer";
import blogs from "./blogs/reducer";
import GiftCardDesign from "./giftcardDesign/reducer";

// Dashboard Pages Reducers
import Card from "../pages/profileDashboard/viewCard/reducers";
import Notification from "./notification/reducer";
import UserOrder from "./userOrders/reducer";
import UserStatement from "./userStatement/reducer";
import UserProfile from "./userProfile/reducer";
import { categoryReducer } from "./category/reducer";
import { navbarReducer } from "./navbar/reducer";

const rootReducer = combineReducers({
    MobileHomepage,
    AllProducts,
    Category: categoryReducer,
    Navbar: navbarReducer,
    BestSeller,
    FeaturedProducts,
    TopFiveProducts,
    EntertainmentProducts,
    SlidersData,
    SelectedCategory,
    Denominations,
    ProductDetail,
    GiftCardDesign,
    productByCategories,
    blogs,
    Card,
    Notification,
    UserOrder,
    UserStatement,
    UserProfile,
});

export default rootReducer;
